import React from "react";
type Props={className?:string;decorative?:boolean};
export const BrandMark:React.FC<Props>=({className="",decorative=false})=>(
  <img src="/handle-mark.svg" className={className} alt={decorative?"":"Handle"}
    aria-hidden={decorative?"true":undefined} width="42" height="42" draggable={false}/>
);
